export const scrollToSection = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(`#${id}`, { offset: -72, duration: 1.4 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTop = () => {
  if (window.__lenis) {
    window.__lenis.scrollTo(0, { duration: 1.4 });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
